/* Render decorative arrows as SVG so iOS cannot substitute coloured emoji. */
(function () {
  var icons = {
    '↗': '<path d="M5 19 19 5M8 5h11v11"/>',
    '→': '<path d="M4 12h16m-7-7 7 7-7 7"/>',
    '↖': '<path d="M19 19 5 5m0 11V5h11"/>',
    '↘': '<path d="M5 5 19 19m-11 0h11V8"/>',
    '➜': '<path d="M4 12h16m-7-7 7 7-7 7"/>',
    '➡': '<path d="M4 12h16m-7-7 7 7-7 7"/>'
  };
  var re = /([↗→↖↘➜➡])\uFE0F?/g;
  function fix(root) {
    var scope = root || document;
    var nodes = scope.querySelectorAll('a, button, .strave-v3-category__arrow, .strave-editorial__arrow');
    nodes.forEach(function (el) {
      if (el.closest('svg') || el.dataset.straveArrowFixed) return;
      var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
      var textNodes = [];
      while (walker.nextNode()) {
        var node = walker.currentNode;
        if (node.parentElement && /^(SCRIPT|STYLE|TEXTAREA|OPTION)$/.test(node.parentElement.tagName)) continue;
        if (re.test(node.nodeValue)) textNodes.push(node);
        re.lastIndex = 0;
      }
      textNodes.forEach(function (node) {
        var value = node.nodeValue;
        var fragment = document.createDocumentFragment();
        var last = 0;
        value.replace(re, function (match, glyph, offset) {
          if (offset > last) fragment.appendChild(document.createTextNode(value.slice(last, offset)));
          var span = document.createElement('span');
          span.className = 'strave-consistent-arrow';
          span.setAttribute('aria-hidden', 'true');
          span.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" focusable="false" aria-hidden="true">' + icons[glyph] + '</svg>';
          fragment.appendChild(span);
          last = offset + match.length;
        });
        if (last < value.length) fragment.appendChild(document.createTextNode(value.slice(last)));
        node.replaceWith(fragment);
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { fix(); });
  else fix();
  document.addEventListener('shopify:section:load', function (event) { fix(event.target); });
})();